import { IFormConfigQualifierAttribute } from "../../service/formconfiguration/FormConfigQualifierAttribute";
import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IQualifier } from "./Qualifier";

export interface TFormConfigSectionQualifier {
  additionalComment: string;
  aggregateFunction: string;
  description: string;
  errorCode: string;
  formSectionId: number;
  id: number;
  label: string;
  labelVisible: boolean;
  orderNumber: number;
  orderNumberVisible: boolean;
  qualifierCode: string;
  required: boolean;
  tooltip: string;
  valid: boolean;
  visiblePublic: boolean;
  width: number;
  attributes: IFormConfigQualifierAttribute[];
  qualifier: IQualifier;
}

export interface IFormConfigSectionQualifier
  extends TFormConfigSectionQualifier {}

const FormConfigSectionQualifier = Model(
  (model: TFormConfigSectionQualifier): IFormConfigSectionQualifier => {
    const _formConfigSectionQualifier: TFormConfigSectionQualifier = Object.assign(
      {},
      model
    );

    let create = (
      formConfigSectionQualifier: IFormConfigSectionQualifier
    ): IFormConfigSectionQualifier => {
      let obj = ValidatableObject(formConfigSectionQualifier);
      return obj;
    };

    let formConfigSectionQualifier = {
      get additionalComment() {
        return _formConfigSectionQualifier.additionalComment;
      },
      set additionalComment(value) {
        _formConfigSectionQualifier.additionalComment = value;
      },
      get aggregateFunction() {
        return _formConfigSectionQualifier.aggregateFunction;
      },
      set aggregateFunction(value) {
        _formConfigSectionQualifier.aggregateFunction = value;
      },
      get description() {
        return _formConfigSectionQualifier.description;
      },
      set description(value) {
        _formConfigSectionQualifier.description = value;
      },
      get errorCode() {
        return _formConfigSectionQualifier.errorCode;
      },
      set errorCode(value) {
        _formConfigSectionQualifier.errorCode = value;
      },
      get formSectionId() {
        return _formConfigSectionQualifier.formSectionId;
      },
      set formSectionId(value) {
        _formConfigSectionQualifier.formSectionId = value;
      },
      get id() {
        return _formConfigSectionQualifier.id;
      },
      set id(value) {
        _formConfigSectionQualifier.id = value;
      },
      get label() {
        return _formConfigSectionQualifier.label;
      },
      set label(value) {
        _formConfigSectionQualifier.label = value;
      },
      get labelVisible() {
        return _formConfigSectionQualifier.labelVisible;
      },
      set labelVisible(value) {
        _formConfigSectionQualifier.labelVisible = value;
      },
      get orderNumber() {
        return _formConfigSectionQualifier.orderNumber;
      },
      set orderNumber(value) {
        _formConfigSectionQualifier.orderNumber = value;
      },
      get orderNumberVisible() {
        return _formConfigSectionQualifier.orderNumberVisible;
      },
      set orderNumberVisible(value) {
        _formConfigSectionQualifier.orderNumberVisible = value;
      },
      get qualifierCode() {
        return _formConfigSectionQualifier.qualifierCode;
      },
      set qualifierCode(value) {
        _formConfigSectionQualifier.qualifierCode = value;
      },
      get required() {
        return _formConfigSectionQualifier.required;
      },
      set required(value) {
        _formConfigSectionQualifier.required = value;
      },
      get tooltip() {
        return _formConfigSectionQualifier.tooltip;
      },
      set tooltip(value) {
        _formConfigSectionQualifier.tooltip = value;
      },
      get valid() {
        return _formConfigSectionQualifier.valid;
      },
      set valid(value) {
        _formConfigSectionQualifier.valid = value;
      },
      get visiblePublic() {
        return _formConfigSectionQualifier.visiblePublic;
      },
      set visiblePublic(value) {
        _formConfigSectionQualifier.visiblePublic = value;
      },
      get width() {
        return _formConfigSectionQualifier.width;
      },
      set width(value) {
        _formConfigSectionQualifier.width = value;
      },
      get attributes() {
        return _formConfigSectionQualifier.attributes;
      },
      set attributes(value) {
        _formConfigSectionQualifier.attributes = value;
      },
      get qualifier() {
        return _formConfigSectionQualifier.qualifier;
      },
      set qualifier(value) {
        _formConfigSectionQualifier.qualifier = value;
      }
    };
    return create(formConfigSectionQualifier);
  }
);

export default FormConfigSectionQualifier;
